import Cookies from "js-cookie";

async function fetchModel(clientId, token) {
  console.log("fetchModel called with clientId:", clientId);
  const api_url = Cookies.get("ApiUrl");
  const apiUrl = `${api_url}/admin/model/list`;

  try {
    const body = clientId ? { ClientId: clientId } : {};

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    const list = data?.message?.list || [];
    console.log("Model list data:", list);
    return list;
  } catch (error) {
    console.error("Error fetching documents:", error);
    throw error;
  }
}

export default fetchModel;
